// src/components/MobileFooter.jsx
import React from 'react';
import logo from "../assets/logo.svg";
import { FOOTER } from "../data/constants";

interface MobileFooterProps {
  onOpenEnquireModal: () => void;
}
const MobileFooter: React.FC<MobileFooterProps> = ({ onOpenEnquireModal }) => (
  
  <footer
    className="w-full h-[603px] bg-cover bg-center text-white px-6  pt-16"
    style={{ backgroundImage: "url('/backdrop.png')" }}
  >
    <div className="flex flex-col items-center space-y-6 ">
      {/* Logo */}
      <img src={logo} alt="SKTuff Logo" className="w-28" />

      {/* Sitemap */}
      <nav className="flex flex-col items-center space-y-[10px] !mt-[40px]">
        {FOOTER.sitemap.map((item) => (
          <a
            key={item.href}
            href={item.href}
            className="font-inter font-medium text-[16px] hover:text-[#46C1BF]"
          >
            {item.label}
          </a>
        ))}
      </nav>

      {/* Enquire Button */}
      <button className="px-8 py-2 bg-white text-black font-semibold  hover:bg-[#46C1BF] hover:text-black hover:[clip-path:polygon(0_0,100%_0,100%_calc(100%_-_16px),calc(100%_-_16px)_100%,0_100%)]" onClick={() => {  onOpenEnquireModal(); }} >
        Enquire
      </button>

      {/* Contact Info */}
      <div className="text-center text-sm leading-relaxed !mt-[56px]">
        <p>{FOOTER.contact.address1}</p>
        <p>{FOOTER.contact.address2}</p>
        <p className="mt-2">
          {FOOTER.contact.phone}{" "}
          <a
            href={`mailto:${FOOTER.contact.email}`}
            className=" hover:underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            {FOOTER.contact.email}
          </a>
        </p>
      </div>

      <p className="text-xs">© SKTUFF 2025. ALL RIGHTS RESERVED</p>
    </div>
  </footer>
);

export default MobileFooter;
